import { render, staticRenderFns } from "./DormUserAccount.vue?vue&type=template&id=5fe5786a&scoped=true&"
import script from "./DormUserAccount.vue?vue&type=script&lang=js&"
export * from "./DormUserAccount.vue?vue&type=script&lang=js&"
import style0 from "./DormUserAccount.vue?vue&type=style&index=0&id=5fe5786a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5786a",
  null
  
)

export default component.exports